import { Input } from "antd";
import { useState } from "react";

type TextInputProps = {
	disabled?: boolean;
	initialValue?: string;
	onChange: (value: string) => void;
	questionText?: string;
	hasError?: boolean;
	addDefaultValue?: string;
	onAddDefault?: () => void;
};

const TextInput = ({
	disabled = false,
	initialValue = "",
	onChange,
	hasError = false,
	addDefaultValue,
	onAddDefault
}: TextInputProps) => {
	const hasDefault = addDefaultValue != null && onAddDefault != null;
	const [value, setValue] = useState(hasDefault ? "" : initialValue);

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		const trimmedValue = e.target.value.trim();
		setValue(trimmedValue);
		onChange(trimmedValue);
	};

	const handleAddDefault = () => {
		if (addDefaultValue != null && onAddDefault != null) {
			setValue(addDefaultValue);
			onAddDefault();
		}
	};

	return (
		<Input
			disabled={disabled}
			placeholder="Enter here"
			value={value}
			onChange={(e) => setValue(e.target.value)}
			onBlur={handleBlur}
			size="large"
			className={hasError ? "edc-input-error" : ""}
			addonAfter={
				hasDefault ? (
					<span
						role="button"
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							handleAddDefault();
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === " ") {
								e.preventDefault();
								handleAddDefault();
							}
						}}
						className="cursor-pointer text-indigo-600 hover:text-indigo-700">
						Add default
					</span>
				) : null
			}
		/>
	);
};

export default TextInput;

